import React, { Component, createRef, Fragment } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import mediaQueries from '../../../../utils/mediaQueries';

const enableIntersectionObserver = false;

class ArrowsAndBottomIcons extends Component {
  constructor() {
    super();
    this.state = {
      visible: false,
    };
    this.$el = createRef();
  }

  componentDidMount() {
    if (!mediaQueries.is_large_up() && enableIntersectionObserver) {
      if (!ArrowsAndBottomIcons.intersectionObserver) {
        ArrowsAndBottomIcons.intersectionObserver = new IntersectionObserver(
          entries => {
            entries.forEach(entry => {
              const { component } = entry.target;
              if (component.state.visible !== entry.isIntersecting) {
                component.setState({ visible: entry.isIntersecting });
              }
            });
          },
          {
            rootMargin: '-30% 0% -20%',
          }
        );
      }

      this.$el.current.component = this;
      ArrowsAndBottomIcons.intersectionObserver.observe(this.$el.current);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { visible } = this.state;
    return visible !== nextState.visible;
  }

  componentWillUnmount() {
    if (ArrowsAndBottomIcons.intersectionObserver) {
      ArrowsAndBottomIcons.intersectionObserver.unobserve(this.$el.current);
    }
  }

  render() {
    const { onZoomClick, onBagClick, onWishlistClick, onArrowLeftClick, onArrowRightClick, intl } = this.props;
    const { visible } = this.state;

    const visibilityClass = visible ? 'inview' : '';

    return (
      <Fragment>
        <div className={`grid__list-item--arrow-left ${visibilityClass}`}>
          <button
            aria-label={intl.formatMessage({ id: 'products.carousel.left' })}
            tabIndex="-1"
            type="button"
            onClick={onArrowLeftClick}
          >
            <i className="fa-light fa-chevron-left" />
          </button>
        </div>
        <div className={`grid__list-item--arrow-right ${visibilityClass}`}>
          <button
            aria-label={intl.formatMessage({ id: 'products.carousel.right' })}
            tabIndex="-1"
            type="button"
            onClick={onArrowRightClick}
          >
            <i className="fa-light fa-chevron-right" />
          </button>
        </div>
        <button
          aria-label={intl.formatMessage({ id: 'wishlist.add.label' })}
          type="button"
          className="grid__list-item--icon-wishlist icon-wishlist"
          onClick={onWishlistClick}
        />
        <button
          aria-label={intl.formatMessage({
            id: 'products.pdp.addToWishlist.addedToWishlistMsg',
          })}
          tabIndex="-1"
          aria-hidden="true"
          type="button"
          className="grid__list-item--icon-wishlist-filled icon-wishlist-filled"
        />
        <div className={`grid__list-item--icons-bottom ${visibilityClass}`} ref={this.$el}>
          <button
            aria-label={intl.formatMessage({
              id: 'products.details.screen.zoom.click',
            })}
            type="button"
            className="grid__list-item--icon-zoom icon-quick-view"
            onClick={onZoomClick}
          />

          <button
            aria-label={intl.formatMessage({ id: 'products.cta.addToCart' })}
            type="button"
            className="grid__list-item--icon-buy"
            onClick={onBagClick}
          >
            <span className="grid__list-item--icon-buy-label">
              <FormattedMessage id="products.cta.addToCart" description="Add to bag" />
            </span>
            <span className="icon-quick-buy" />
          </button>
        </div>
      </Fragment>
    );
  }
}

ArrowsAndBottomIcons.defaultProps = {
  onZoomClick: null,
  onBagClick: null,
  onWishlistClick: null,
  onArrowLeftClick: null,
  onArrowRightClick: null,
};

ArrowsAndBottomIcons.propTypes = {
  onZoomClick: PropTypes.func,
  onBagClick: PropTypes.func,
  onWishlistClick: PropTypes.func,
  onArrowLeftClick: PropTypes.func,
  onArrowRightClick: PropTypes.func,
};

export default injectIntl(ArrowsAndBottomIcons);
